import CryptoJS from "crypto-js";

// 与 facai7_app/utils/Secret.js、后端 Password::decryptTransport 保持一致
const KEY = CryptoJS.enc.Utf8.parse("c76881f43f4140a7");
const IV = CryptoJS.enc.Utf8.parse("7fc0fb1c8731495e");

const SENSITIVE_KEYS = ["password", "confirmPassword", "pin", "withdraw"];

/**
 * AES-128-CBC ZeroPadding，返回 Base64 密文
 */
export function Encrypt(word, keyStr, ivStr) {
  let key = KEY;
  let iv = IV;
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }
  const srcs = CryptoJS.enc.Utf8.parse(String(word));
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/**
 * 加密对象中的敏感字段（密码等）
 */
export function encryptSensitive(data) {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return data;
  }
  const out = { ...data };
  SENSITIVE_KEYS.forEach((key) => {
    if (out[key] != null && out[key] !== "") {
      out[key] = Encrypt(String(out[key]));
    }
  });
  return out;
}
